import React from 'react';

import styled from 'styled-components/macro';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

const LabelWithTooltip = styled('span')`
  border-bottom: 1px dashed;
  line-height: 1.2rem;
`;

type Abbreviation = { abbreviation: string };

const abbreviations: Abbreviation[] = [
  { abbreviation: 'ROW' },
  { abbreviation: 'APAC' },
  { abbreviation: 'MENA' },
  { abbreviation: 'SE' },
  { abbreviation: 'GCC' },
  { abbreviation: 'CIS+' },
];

const isAbbreviation = (word: string): Abbreviation | undefined => {
  return abbreviations.find((abb: Abbreviation) => abb.abbreviation === word);
};

const getLabel = (
  label: string,
  definition: string
): (JSX.Element | string)[] =>
  label.split(' ').map((word: string) => {
    return isAbbreviation(word) ? (
      <TippyToolTip
        key={`${label}-${word}`}
        tooltipContent={definition}
        enabled
        maxWidth={definition?.length > 30 ? '170px' : 'none'}
      >
        <LabelWithTooltip>{word}</LabelWithTooltip>
        &nbsp;
      </TippyToolTip>
    ) : (
      `${word} `
    );
  });

export const getDefinition = (label: string, definition: string): string => {
  return isAbbreviation(label) ? definition : label;
};

export default getLabel;
